import { createAction } from 'redux-act';
import { GET } from 'gandi.redux-fetcher';
export const fetchRenewDurationsStart = createAction('fetching renew durations');
export const fetchRenewDurationsSuccess = createAction('renew durations received');
export const fetchRenewDurationsFail = createAction('renew durations not received');
export const fetchRenewDurations = product => dispatch => {
  const fqdn = product.fqdn;
  if (!fqdn) {
    return Promise.resolve();
  }
  const productId = product.id;
  dispatch(fetchRenewDurationsStart(productId));
  return dispatch(GET(`/domain-anonymous/domains/${fqdn}/renew`, {
    on2XX: response => {
      dispatch(fetchRenewDurationsSuccess({
        productId,
        data: response.data
      }));
    },
    not2XX: () => {
      dispatch(fetchRenewDurationsFail(productId));
    }
  }));
};